// Emergent Google Auth button
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
import { Button } from "./ui/button";

export function GoogleAuthButton({ label = "Continue with Google", testId = "google-auth-btn" }) {
  const startGoogle = () => {
    // Derive redirect from current origin dynamically. No hardcoding, no fallback.
    const redirectUrl = window.location.origin + "/auth/callback";
    window.location.href =
      "https://auth.emergentagent.com/?redirect=" + encodeURIComponent(redirectUrl);
  };
  return (
    <Button
      type="button"
      onClick={startGoogle}
      variant="outline"
      className="w-full btn-press bg-white text-black hover:bg-white/90"
      data-testid={testId}
    >
      <svg width="18" height="18" viewBox="0 0 48 48" className="mr-2" aria-hidden>
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.9 32.1 29.4 35 24 35c-6.1 0-11-4.9-11-11s4.9-11 11-11c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.8 6.9 29.1 5 24 5 13.5 5 5 13.5 5 24s8.5 19 19 19 19-8.5 19-19c0-1.2-.1-2.3-.4-3.5z"/>
        <path fill="#FF3D00" d="M6.3 14.7l6.6 4.8C14.7 16 19 13 24 13c2.8 0 5.4 1 7.4 2.8l5.7-5.7C33.8 6.9 29.1 5 24 5c-7.4 0-13.9 4.2-17.7 9.7z"/>
        <path fill="#4CAF50" d="M24 43c5.1 0 9.7-1.8 13.3-4.9l-6.1-5.2C29.1 34.8 26.7 36 24 36c-5.3 0-9.8-3.6-11.4-8.5l-6.5 5C9.9 39.7 16.4 43 24 43z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.4-2.4 4.4-4.4 5.9l6.1 5.2C40.9 35.8 44 30.4 44 24c0-1.2-.1-2.3-.4-3.5z"/>
      </svg>
      {label}
    </Button>
  );
}
